import * as actionTypes from "../actionTypes";

const initialState = {
    rolesData: [],
    activityLogsData: [],
    activityLogsPagination: {},
    modulesData: [],
};

const roleReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_ROLES: {
            return { ...state, rolesData: payload };
        }
        case actionTypes.SET_ACTIVITY_LOGS: {
            return { 
                ...state, 
                activityLogsData: payload?.results || payload,
                activityLogsPagination: payload?.pagination || {}
            };
        }
        case actionTypes.SET_MODULES: {
            return { ...state, modulesData: payload };
        }
        default: {
            return state;
        }
    }
};

export default roleReducer;
